import React, { useEffect, useState, useRef } from "react";
import Masonry from "react-masonry-css";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown } from "@fortawesome/free-solid-svg-icons"; // Cambia el icono de descarga
import "./Gallery.css";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const observer = useRef();

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(
          `/backend/list_images.php?page=${page}`
        );
        const data = await response.json();

        if (data.length === 0) {
          setHasMore(false); // No hay más imágenes
          return;
        }

        const processedImages = data.map((relativePath) => {
          const cleanPath = relativePath.replace(/\\/g, "");

          let filename = cleanPath
            .split("/")
            .pop()
            .replace(/\.(jpg|jpeg|png)$/i, ".webp");
          const thumbnail = `/fts/redi/${filename}`;
          const full = `/fts/${filename}`;

          return { thumbnail, full };
        });

        setImages((prevImages) => [...prevImages, ...processedImages]);
      } catch (error) {
        console.error("Error al cargar imágenes:", error);
      }
    };

    fetchImages();
  }, [page]);

  useEffect(() => {
    if (!hasMore) return;

    const loadMoreTrigger = document.getElementById("load-more-trigger");

    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          console.log("Load more trigger is intersecting");
          setPage((prevPage) => prevPage + 1);
        }
      },
      { threshold: 1.0 }
    );

    if (loadMoreTrigger) {
      observer.current.observe(loadMoreTrigger);
    }

    return () => {
      if (observer.current) observer.current.disconnect();
    };
  }, [hasMore]);

  const breakpointColumnsObj = {
    default: 4,
    1100: 3,
    700: 2,
    500: 2, // Asegúrate de que haya al menos 2 columnas en pantallas pequeñas
  };

  const handleDownload = (url) => {
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      // Si es un dispositivo móvil, muestra un popup antes de abrir la imagen
      const confirmMessage =
        "Se va a abrir la imagen en una nueva ventana, mantenga presionado para poder guardarla en la galería.";
      if (window.confirm(confirmMessage)) {
        window.open(url, "_blank");
      }
    } else {
      // Si es un dispositivo de escritorio, descarga la imagen
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <div className="gallery">
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {images.map((img, index) => (
          <div key={index} className="image-container">
            <img
              src={img.thumbnail}
              alt={`Imagen ${index}`}
              loading="lazy"
              onLoad={(e) => {
                e.target.nextSibling.style.display = "block"; // Muestra el icono de descarga después de que la imagen se haya cargado
              }}
              onClick={() => {
                setCurrentIndex(index);
                setLightboxOpen(true);
              }}
            />
            <FontAwesomeIcon
              icon={faArrowDown} // Cambia el icono de descarga
              className="download-icon"
              style={{ display: "none" }} // Oculta el icono de descarga inicialmente
              onClick={(e) => {
                e.stopPropagation(); // Evita que se abra el lightbox
                handleDownload(img.full);
              }}
            />
          </div>
        ))}
      </Masonry>

      {hasMore && <div id="load-more-trigger" style={{ height: "1px" }}></div>}

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={images.map((img) => ({ src: img.thumbnail }))}
        index={currentIndex}
        render={{
          slide: ({ slide }) => (
            <div className="lightbox-slide">
              <img
                src={slide.src}
                alt=""
                onLoad={(e) => {
                  e.target.nextSibling.style.display = "block"; // Muestra el icono de descarga después de que la imagen se haya cargado
                }}
              />
              <FontAwesomeIcon
                icon={faArrowDown} // Cambia el icono de descarga
                className="download-icon"
                style={{ display: "none" }} // Oculta el icono de descarga inicialmente
                onClick={() => handleDownload(slide.src)}
              />
            </div>
          ),
        }}
      />
    </div>
  );
};

export default Gallery;
